<template>
  <component :is="type + 'Add'" v-if="type" ref="addEnergeticModal" />
</template>
<script>
import PowerAdd from './power/Add'
import GasAdd from './gas/Add'
import WaterAdd from './water/Add'
import HeatAdd from './heat/Add'

export default {
  components: {
    PowerAdd,
    GasAdd,
    WaterAdd,
    HeatAdd,
  },
  data() {
    return {
      type: null,
      edit: false,
    }
  },
  methods: {
    saveEnergetic(e) {
      e.preventDefault()
      this.$refs.addEnergeticModal.$validator.validateAll().then(() => {
        if (
          !this.$refs.addEnergeticModal.errors.any() &&
          !this.$refs.addEnergeticModal.loading
        ) {
          this.$refs.addEnergeticModal.saving = true
          this.$api
            .post(
              this.edit ? 'energetics/edit' : 'energetics/add',
              this.$refs.addEnergeticModal.form,
            )
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              })
              this.$root.$emit('modal-hide', 'add-energetic')
              this.$root.$emit('reloadCustomerEnergeticsData')
              if (!this.edit) {
                this.$router.push({
                  name: 'customerEnergeticsDetail',
                  params: { energetics_id: res.data.meta.id },
                })
              }
            })
            .catch((err) => {
              this.$swal({
                type: 'error',
                position: 'top',
                showCloseButton: true,
                text:
                  err.response.data.message ||
                  'Vyskytla sa chyba pri aktualizovaní odberného miesta',
                timer: 5000,
              }).finally(() => {
                this.$refs.addEnergeticModal.saving = false
              })
            })
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
